// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2cw1X","footer":"ModalError_footer__3FGQx"};